export const environment = {
  production: true,
  apiUrl: 'https://pantherasportclub.com:3000',
  firebase: {
    apiKey: 'AIzaSyAM9CpoLairX6IWZ8Wd_nCa1yorbES5rzU',
    authDomain: 'panthera-9ffb1.firebaseapp.com',
    projectId: 'panthera-9ffb1',
    storageBucket: 'panthera-9ffb1.firebasestorage.app',
    messagingSenderId: '759038148820',
    appId: '1:759038148820:web:07cd95132c2facbdbebb41',
    vapidKey: 'BBz4FObhEztep5ER8l7ORc7uV5o8ycJCzynxlgOmaYPPcymBpQNiYJ1OvDm40R8tJaEJp8HELERtFAoEa-OR89U'  // Para notificaciones push
  }
};
